import { UserShortInfo } from '@shared/types/user';

function formatDecimal(value: number | null | undefined, ...args: unknown[]): string {
    if (value === null || value === undefined) {
        return '0';
    }
    const decimalPlaces = args?.length > 0 ? Number(args[0]) : 2;

    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
    }).format(value);
}

function normalizeSpaces(str: string): string {
    return str.replace(/\s+/g, ' ').trim();
}

function computeUserShortName(firstName: string | null, lastName: string | null): string {
    const normalizedFirst = normalizeSpaces(firstName || '');
    const normalizedLast = normalizeSpaces(lastName || '');
    return normalizedFirst + (normalizedLast ? ' ' + normalizedLast[0] + '.' : '');
}

function computeUserFullName(firstName: string | null, lastName: string | null): string {
    const normalizedFirst = normalizeSpaces(firstName || '');
    const normalizedLast = normalizeSpaces(lastName || '');
    return normalizedFirst + (normalizedLast ? ' ' + normalizedLast : '');
}

function mapUserToUserShortInfo(data: any): UserShortInfo | null {
    if (!data) {
        return null;
    }

    return {
        id: data.id,
        firstName: data.firstName,
        lastName: data.lastName,
        fullName: computeUserFullName(data.firstName || '', data.lastName || ''),
        email: data.userName,
    };
}

function formatCurrency(
    value: number | null | undefined,
    currency: { currencySymbolBefore?: string; currencySymbolAfter?: string }
): string {
    if (value === null || value === undefined) {
        return '';
    }
    const formattedValue = value === 0 ? '0' : value.toFixed(2);
    if (!currency) {
        return formattedValue;
    }
    if (currency.currencySymbolBefore) {
        return `${currency.currencySymbolBefore}${formattedValue}`;
    } else if (currency.currencySymbolAfter) {
        return `${formattedValue}${currency.currencySymbolAfter}`;
    } else {
        return formattedValue;
    }
}

export const FormatterHelper = {
    normalizeSpaces,
    formatDecimal,
    computeUserShortName,
    computeUserFullName,
    mapUserToUserShortInfo,
    formatCurrency,
};
